<div class="payment">
    <div class="box">
        <form class="example-form" [formGroup]="form" (ngSubmit)="pay(ammount)">
            <h2 align="center" style="margin-top: 10px;margin-bottom: 20px;">Payments</h2>
            <!-- <mat-form-field class="example-full-width border-white" appearance="outline">
                <mat-label>card number</mat-label>
                <input matInput placeholder="Enter your card number" formControlName="cardnumber" id="cardnumber"
                    [(ngModel)]="cardnumber" type="text" required maxlength="16"/>
                <mat-error *ngIf="f.cardnumber.errors?.required">
                    cardnumber is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            <table class="example-full-width" cellspacing="0"><tr>
                <td><mat-form-field class="example-full-width border-white" appearance="outline">
                  <mat-label>MM/YY</mat-label>
                  <input matInput placeholder="MM/YY" formControlName="exdate" id="exdate"
                  [(ngModel)]="exdate" type="text" required>
                  <mat-error *ngIf="f.exdate.errors?.required">
                    cardnumber is <strong>required</strong>
                </mat-error>
                </mat-form-field></td>

                <td><mat-form-field class="example-full-width border-white" appearance="outline">
                  <mat-label>CVC</mat-label>
                  <input matInput placeholder="CVC" formControlName="cvcnumber" id="cvcnumber"
                  [(ngModel)]="cvcnumber" type="text" required>
                  <mat-error *ngIf="f.cvcnumber.errors?.required">
                    cardnumber is <strong>required</strong>
                </mat-error>
                </mat-form-field></td>
              </tr></table> -->
            <br>
            <!-- <p style="color: red;" align="center">{{Message}}</p> -->

            <mat-form-field class="example-full-width border-white" appearance="outline">
                <mat-label>Enter Locker No.</mat-label>
                <input matInput placeholder="Enter your locker number" formControlName="locknumber" id="locknumber"
                    [(ngModel)]="locknumber" type="text" required numbersOnly/>
                <mat-error *ngIf="f.locknumber.errors?.required">
                   Locker Number is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="example-full-width border-white" appearance="outline">
                <mat-label>Enter Amount</mat-label>
                <input matInput placeholder="Enter Amount" formControlName="ammount" id="ammount"
                    [(ngModel)]="ammount" type="text" required numbersOnly/>
                <mat-error *ngIf="f.ammount.errors?.required">
                    Amount is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            <div class="center">
                <button mat-raised-button color="primary" class="btn button-style"
                    type="submit" [disabled]="!form.valid">Pay {{ammount | currency:'&#8377;'}}</button>
                <!-- [disabled]="!form.valid" -->
            </div>
            <!-- <p>We accept all major credit cards</p> -->
            <div style="padding: 50px 0 0 0;">
                <p style="color: green;font-size: 18px;">We accept all major credit cards</p>
                <img src="assets\Images\VisaMCDiscoverAE-1024x238.jpeg" width="60%" height="30%">
            </div>

        </form>
    </div>
</div>
